import { FormInput } from "../../../FormComponents/Input/Input";
import { Checkbox } from "../../../FormComponents/Checkbox";
import { VonAccessRights } from "../../../../Constants/VON/EmployeeForm/vonAccessRights";
import { VonEmployeeTypes } from "../../../../Constants/VON/EmployeeForm/vonEmployeeTypes";
import { useTranslation } from "react-i18next";

const VonEditEmployeeDetailsForm = ({ form, onChange, isEditDisabled }) => {
    const { t } = useTranslation();
    const { data } = form || {};

    const onCheckPrimaryContact = (value) => {
        if (value) {
            onChange(form.id, VonAccessRights.Administrator, 'onlineRoleId');
            onChange(form.id, data.employeeId, 'newMainContactId');
        } else {
            return onChange(form.id, null, 'newMainContactId');
        }
    }

    const disabled = data.isPrimaryContact || data.employeeTypeId == VonEmployeeTypes.Conversion || isEditDisabled

    return <div>
        <fieldset className="d-grid col gap-16 mb-0">
            <legend>{t('vonaccountformcontainer.userinformation')}</legend>
            <FormInput label={t('common.name')} readOnly value={data.name} />
            <FormInput label={t('common.email')} readOnly value={data.email} />
            <Checkbox label={t('vonaccountformcontainer.maincontact')} checked={data.isPrimaryContact || data.newMainContactId} disabled={disabled} onChange={(value) => onCheckPrimaryContact(value)} />
        </fieldset>
    </div>
}

export default VonEditEmployeeDetailsForm;